import { Controller } from "@hotwired/stimulus"

// Copies the text of a field, and says so on the button that was pressed.
// Connects to data-controller="clipboard"
export default class extends Controller {
  static targets = ["source"]

  copy(event) {
    const button = event.currentTarget
    const label = button.textContent

    this.sourceTarget.select()
    navigator.clipboard.writeText(this.sourceTarget.value)
    button.textContent = "Copied"
    setTimeout(() => { button.textContent = label }, 2000)
  }
}
